import * as React from 'react';
import Grid from '../../components/controls/grid/Grid';
import Section from '../../components/controls/grid/Section';
import Row from '../../components/controls/grid/Row';
import Text from '../../components/controls/Text';
import ComboBox from '../../components/controls/ComboBox';
import { useLeapData } from '../../hooks/useLeapData';
import { useLeapState } from '../../hooks/useLeapState';

type Props = { state: any, controller: any }

export default (props: Props) => {
    const page = useLeapState(props.controller, false)

    const name = useLeapData("name", "nome permesso", page)
    const unit = useLeapData("unit", "funzione menu", page, "units")
    const role = useLeapData("role", "ruolo", page, "roles")

    return (
        <>
            <Grid>
                <Section>
                    <Row>
                        <Text {...name} className="ms-sm12" required maxlength={50} />
                    </Row>
                    <Row>
                        <ComboBox {...unit} className="ms-sm12" required />
                    </Row>
                    <Row>
                        <ComboBox {...role} className="ms-sm12" required />
                    </Row>
                </Section>
            </Grid>
        </>
    );
}
